import React from "react";
import { DETECTION_RULES } from "../data/DetectionRules";
import RuleGroup from "./RuleGroup";

export default function RulesPanel({
  toggles,
  onToggle,
  dropdownValues,
  onDropdownChange,
}) {
  let idx = 0;
  return (
    <div className="space-y-8">
      <h2 className="text-base font-bold text-gray-900 mb-2">
        🧠 Detection Rules (Standard + Advanced)
      </h2>
      {DETECTION_RULES.map((group) => {
        const groupComponent = (
          <RuleGroup
            key={group.group}
            group={group.group}
            items={group.items}
            toggles={toggles}
            baseIdx={idx}
            onToggle={onToggle}
            dropdownValues={dropdownValues}
            onDropdownChange={onDropdownChange}
          />
        );
        idx += group.items.length;
        return groupComponent;
      })}
    </div>
  );
}
